import * as React from 'react';

import { ButtonProps } from '../types';
import { ButtonStyle } from './button.style'

const Button: React.FC<ButtonProps> = ({
  text,
  onClick,
  color = 'primary',
  disabled = false,
  startIcon,
  endIcon,
  form,
  square = false,
  sizeCustom = 'large',
  className,
  type = 'button'
}) => {
  return (
    <ButtonStyle
        color={color}
        sizeCustom={sizeCustom}
        square={square}
        onClick={onClick}
        disabled={disabled}
        startIcon={startIcon}
        endIcon={endIcon}
        className={className}
        text={text}
        type={type}
        form={form}
    >
      { text }
    </ButtonStyle>
  );
};

export { Button };
